<template>
  <div class="table-container">
    <TableCommon
      title="字典数据"
      :checkbox-config="{ highlight: true }"
      :radio-config="{ highlight: true }"
      :custome-config="() => vxeShowCustom('xTable')"
    >
      <template #button>
        <table-button v-if="mode=== 'add'" name="add" tip="新建" @click="addRow" />
        <table-button v-if="mode=== 'add'" name="add" tip="删除" @click="removeRow" />
      </template>
      <vxe-grid
        ref="xTableEdit"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="300"
        max-height="500"
        align="center"
        size="mini"
        :checkbox-config="{ highlight: true }"
        :radio-config="{ highlight: true }"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions.columns"
        :data="gridOptions.data"
      >
        <template #reward_number="{row}">
          <el-input v-model="row.reward_number" placeholder="" size="mini" disabled/>
        </template>
        <template #reward_id="{row}">
          <wly-input
            :disabled="mode=== 'edit'"
            v-model="row.reward_id"
            @handleSuffixClick="openDialog($event, row,'奖励选择')"
          />
          <!-- <el-input v-model="row.reward_id" placeholder="请输入" size="mini" /> -->
        </template>
        <template #reward_name="{row}">
          <el-input v-model="row.reward_name" :disabled="mode=== 'edit'" placeholder="请输入" size="mini" />
        </template>
        <template #customer="{row}">
          <wly-input
            :disabled="mode=== 'edit'"
            v-model="row.customer"
            input-type="customer"
            @enter="handleEnter(...arguments, row)"
            @handleSuffixClick="openDialog($event, row,'客户选择')"
          />
        </template>
        <template #customer_name="{row}">
          <el-input v-model="row.customer_name" :disabled="mode=== 'edit'" placeholder="请输入客户名称" size="mini" />
        </template>
        <template #bp_role="{row}">
          <el-select
            v-model="row.bp_role"
            size="mini"
            placeholder=""
            clearable
          >
            <el-option
              v-for="item2 in selectDataOptions['A0079']"
              :key="item2.value"
              :label="item2.name"
              :value="item2.value"
            />
          </el-select>
        </template>
        <template #amount="{row}">
          <el-input v-model="row.amount" placeholder="请输入金额" size="mini" />
        </template>
        <template #remark="{row}">
          <el-input v-model="row.remark" placeholder="请输入备注" size="mini" />
        </template>
        <template #status="{row}">
          <el-link
            size="mini"
            :type="row.status == 'V001' ? 'success' : 'danger'"
            effect="dark"
          >
            {{ row.status_text }}
          </el-link>
        </template>
      </vxe-grid>

    </TableCommon>
    <el-dialog
      v-dialogDrag
      title="客户选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
        <rewardProjectData v-else ref="dialogSelect"/>
        <!-- <product-select ref="dialogSelect" /> -->
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import rewardProjectData from './rewardProjectData.vue'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
export default {
  components: { ClientSelect, rewardProjectData },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    editRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showDialog: false,
      rowSeq: 0,
      selectDataOptions: {
        orgList: []
      },
      gridOptions: {
        data: [],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          { field: 'reward_number', title: '项目编码', slots: { default: 'reward_number' }},
          { field: 'reward_id', title: '项目类型编码', slots: { default: 'reward_id' }},
          { field: 'reward_name', title: '项目类型描述', slots: { default: 'reward_name' }},
          { field: 'customer', title: '客户编号', slots: { default: 'customer' }},
          { field: 'customer_name', title: '客户名称', slots: { default: 'customer_name' }},
          { field: 'bp_role', title: '奖励角色类型', slots: { default: 'bp_role' }},
          { field: 'amount', title: '金额（元）', width: 120, slots: { default: 'amount' }},
          { field: 'remark', title: '备注', width: 120, slots: { default: 'remark' }},
          { field: 'status', title: '状态', width: 100, slots: { default: 'status' }},
        ]
      },
      defaultsData: {},
      currentRow: null,
      dialogTitle: '客户选择'
    }
  },
  created() {
    this.defaultsData =  {
      reward_number: '',
      reward_id: '',
      reward_name: '',
      customer: '',
      customer_name: '',
      amount: '',
      remark: '',
      status: '',
    }
    if (this.editRows.length) {
      this.gridOptions.data.push(...this.editRows.map(item => {
        return { ...item }
      }))
    } else {
      this.gridOptions.data.push({
        ...this.defaultsData
      })
    }
    this.getSelectDictDataOrigin('A0079')
  },
  methods: {
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      console.log(`output->datalail`,data)
      if (data) {
        if (this.dialogTitle === '客户选择') {
          this.currentRow.customer = data.customerCode
          this.currentRow.customer_name = data.customerName
        } else if (this.dialogTitle === '奖励选择') {
          this.currentRow.reward_id = data.reward_id
          this.currentRow.reward_name = data.reward_name
        }
      }
      this.showDialog = false
    },
    openDialog(e, row, title) {
      this.showDialog = true
      this.currentRow = row
      this.dialogTitle = title
    },
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return
      this.currentRow = row
      this.currentRow.customer = data.partner
      this.currentRow.customer_name = data.name_org1
    },
    addRow() {
      this.gridOptions.data.push({
        ...this.defaultsData
      })
    },
    removeRow() {
      const checkedList = this.$refs['xTableEdit'].getCheckboxRecords()
      if (!checkedList.length) return

      checkedList.forEach(file => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    validRows() {
      try {
        if (!this.gridOptions.data.length) {
          throw new Error('请添加要保存的数据！')
        }
        this.gridOptions.data.forEach(item => {
          if (!item.reward_id || !item.reward_name || !item.customer || !item.customer_name|| !item.amount) {
            throw new Error('请输入完整的信息！')
          }
        })
      } catch (e) {
        this.$message.error(e.message)
        return false
      }

      return this.gridOptions.data
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/reward-policy/components/customerEdit.vue